module.exports = "<app-header></app-header>\r\n<div style=\"margin-top: 7.5em;\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/promotion/layout-promotion/layout-promotion.component.html
// module id = ./src/app/promotion/layout-promotion/layout-promotion.component.html
// module chunks = main